/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tier_1_DInputs */

const en_cp_tier_1_d = /** @type {(inputs: Cp_Tier_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted and first build night done. Free seat, kit, lead group.`)
};

const id_cp_tier_1_d = /** @type {(inputs: Cp_Tier_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterima dan build night pertama selesai. Kursi gratis, kit, grup lead.`)
};

/**
* | output |
* | --- |
* | "Accepted and first build night done. Free seat, kit, lead group." |
*
* @param {Cp_Tier_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tier_1_d = /** @type {((inputs?: Cp_Tier_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tier_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tier_1_d(inputs)
	return en_cp_tier_1_d(inputs)
});